import { handleActions } from 'redux-actions';
import {
  trackerSettingsFetchInitialized,
  trackerSettingsFetchSucceeded,
  trackerSettingsFetchFailed,
  trackerSettingsUpdateSucceeded,
  TrackerSettingsResponse,
} from '../TrackerSettings';

interface TrackerSettingsState {
  isLoading: boolean
  settings?: TrackerSettingsResponse
  failed: boolean
}

const initialState: TrackerSettingsState = {
  isLoading: true,
  failed: false,
};

export default handleActions<TrackerSettingsState, any>({
  [trackerSettingsFetchInitialized as any]: (state: TrackerSettingsState) => ({
    ...state,
    isLoading: true,
    failed: false,
  }),
  [trackerSettingsFetchSucceeded as any]: (
    state: TrackerSettingsState,
    { payload }: { payload: TrackerSettingsResponse },
  ) => ({
    ...state,
    isLoading: false,
    settings: payload,
  }),
  [trackerSettingsFetchFailed as any]: state => ({
    ...state,
    failed: true,
    isLoading: false,
  }),
  [trackerSettingsUpdateSucceeded as any]: (state: TrackerSettingsState, { payload }) => ({
    ...state,
    settings: {
      ...state.settings,
      attributes: {
        ...(state.settings as TrackerSettingsResponse).attributes,
        ...payload,
      },
    },
  } as TrackerSettingsState),
}, initialState);
